import { Calendar } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function JobsTableRow({ job, onDelete, onEdit, onViewQuote, canDeleteJob = true }) {

    return (
        <tr
            className="border-b border-gray-100 hover:bg-gray-50 transition cursor-pointer"
        >
            <td className="px-3 py-3">
                <div className="font-medium text-gray-900">{job.client}</div>
                <div className="text-xs text-gray-500">{job.clientSubtitle}</div>
            </td>
            <td className="px-3 py-3 font-medium text-gray-700">{job.jobNumber}</td>
            <td className="px-3 py-3 font-medium text-gray-700">{job.raw?.quote_id || '-'}</td>
            <td className="px-3 py-3 font-medium text-gray-700">{job.title}</td>
            <td className="px-3 py-3 text-xs text-gray-600 font-medium">{job.property}</td>
            <td className="px-3 py-3 text-xs text-gray-700">
                {job.raw?.quote?.boat_type || '-'}
            </td>
            <td className="px-3 py-3 text-xs text-gray-600 flex items-center gap-1">
                <Calendar className="w-3.5 h-3.5" />
                {job.schedule}
            </td>
            <td className="px-3 py-3">
                <span className={`px-2.5 py-1 rounded-full text-xs font-medium ${job.status === 'Today' ? 'bg-blue-100 text-blue-700' : 'bg-emerald-100 text-emerald-700'}`}>
                    {job.status}
                </span>
            </td>
            {/* <td className="px-3 py-3" onClick={e => e.stopPropagation()}>
                {job.raw?.quote ? (
                    <button
                        type="button"
                        onClick={() => onViewQuote(job)}
                        className="px-3 py-1 text-xs font-semibold rounded-lg bg-blue-50 text-blue-700 hover:bg-blue-100 border border-blue-200 transition"
                    >
                        View Quote
                    </button>
                ) : (
                    <span className="text-xs text-gray-400">-</span>
                )}
            </td> */}
            {/* <td className="px-3 py-3 font-medium text-gray-900">{job.total}</td> */}
            <td className="px-3 py-3" onClick={e => e.stopPropagation()}>
                <div className="flex items-center gap-2">
                    {onEdit && (
                        <button
                            onClick={() => onEdit(job)}
                            className="text-blue-600 hover:text-blue-700 text-xs font-medium"
                        >
                            Edit
                        </button>
                    )}
                    {canDeleteJob && onDelete && (
                        <button
                            onClick={() => onDelete(job.id)}
                            className="text-red-600 hover:text-red-700 text-xs font-medium"
                        >
                            Delete
                        </button>
                    )}
                    <Link
                        to={`/profile/details/jobs/datatables/${job.id}`}
                        className="text-xs font-medium text-gray-700 hover:text-gray-900"
                    >
                        View
                    </Link>
                </div>
            </td>
        </tr>
    );
}